import apiMiddleware from "../api/apiMiddleware";

// Activity General CRUD
export const getActivities = async (page = 1, filters = {}) => {
    const queryParams = new URLSearchParams({
        page,
        ...filters,
    }).toString();
    const response = await apiMiddleware.get(`/activities?${queryParams}`);
    return response.data;
};

export const createActivity = async (data) => {
    const response = await apiMiddleware.post("/activities", data, {
        headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
};

export const updateActivity = async (id, data) => {
    const response = await apiMiddleware.post(`/activities/${id}?_method=PUT`, data, {
        headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
};

export const deleteActivity = async (id) => {
    const response = await apiMiddleware.delete(`/activities/${id}`);
    return response.data;
};

export const getActivityById = async (id) => {
    const response = await apiMiddleware.get(`/activities/${id}`);
    return response.data;
};

export const toggleActivityStatus = async (id) => {
    const response = await apiMiddleware.patch(`/activities/${id}/toggle-status`);
    return response.data;
};

// Activity Categories
export const getActivityCategories = async () => {
    const response = await apiMiddleware.get(`/activity-categories-active`);
    return response.data;
};

export const createActivityCategory = async (data) => {
    const response = await apiMiddleware.post(`/activity-categories`, data);
    return response.data;
};

// Ticket Master (Activity Ticket) functions
export const getActivityTickets = async (activityId) => {
    const response = await apiMiddleware.get(`/activities/${activityId}/ticket-types`);
    return response.data;
};

export const createActivityTicket = async (activityId, data) => {
    const response = await apiMiddleware.post(`/activities/${activityId}/ticket-types`, data);
    return response.data;
};

export const updateActivityTicket = async (activityId, ticketId, data) => {
    const response = await apiMiddleware.put(`/activities/${activityId}/ticket-types/${ticketId}`, data);
    return response.data;
};

export const deleteActivityTicket = async (activityId, ticketId) => {
    const response = await apiMiddleware.delete(`/activities/${activityId}/ticket-types/${ticketId}`);
    return response.data;
};

export const toggleActivityTicketStatus = async (activityId, ticketId) => {
    const response = await apiMiddleware.patch(`/activities/${activityId}/ticket-types/${ticketId}/toggle-status`);
    return response.data;
};

// Activity Ticket Type Time Slots
export const getActivityTicketTypeTimeSlots = async (activityId, ticketTypeId) => {
    const response = await apiMiddleware.get(
        `/activities/${activityId}/ticket-types/${ticketTypeId}/time-slots`
    );
    return response.data;
};

export const createActivityTicketTypeTimeSlot = async (activityId, ticketTypeId, data) => {
    const response = await apiMiddleware.post(
        `/activities/${activityId}/ticket-types/${ticketTypeId}/time-slots`,
        data
    );
    return response.data;
};

export const updateActivityTicketTypeTimeSlot = async (activityId, ticketTypeId, slotId, data) => {
    const response = await apiMiddleware.put(
        `/activities/${activityId}/ticket-types/${ticketTypeId}/time-slots/${slotId}`,
        data
    );
    return response.data;
};

export const deleteActivityTicketTypeTimeSlot = async (activityId, ticketTypeId, slotId) => {
    const response = await apiMiddleware.delete(
        `/activities/${activityId}/ticket-types/${ticketTypeId}/time-slots/${slotId}`
    );
    return response.data;
};

// Activity Inclusions
export const getActivityInclusions = async (activityId, ticketTypeId) => {
    const response = await apiMiddleware.get(`/activities/${activityId}/ticket-types/${ticketTypeId}/inclusions`);
    return response.data;
};

export const createActivityInclusion = async (activityId, ticketTypeId, inclusions) => {
    const response = await apiMiddleware.post(`/activities/${activityId}/ticket-types/${ticketTypeId}/inclusions`, {
        inclusions: inclusions // Backend expects an array of strings
    });
    return response.data;
};

export const deleteActivityInclusion = async (activityId, ticketTypeId, inclusionId) => {
    const response = await apiMiddleware.delete(`/activities/${activityId}/ticket-types/${ticketTypeId}/inclusions/${inclusionId}`);
    return response.data;
};

// Activity Exclusions
export const getActivityExclusions = async (activityId, ticketTypeId) => {
    const response = await apiMiddleware.get(`/activities/${activityId}/ticket-types/${ticketTypeId}/exclusions`);
    return response.data;
};

export const createActivityExclusion = async (activityId, ticketTypeId, exclusions) => {
    const response = await apiMiddleware.post(`/activities/${activityId}/ticket-types/${ticketTypeId}/exclusions`, {
        exclusions: exclusions
    });
    return response.data;
};

export const deleteActivityExclusion = async (activityId, ticketTypeId, inclusionId) => {
    const response = await apiMiddleware.delete(`/activities/${activityId}/ticket-types/${ticketTypeId}/exclusions/${inclusionId}`);
    return response.data;
};

// Activity Inclusions by Activity
export const getActivityInclusionsByActivity = async (activityId) => {
    const response = await apiMiddleware.get(`/activity-inclusions?activity_id=${activityId}`);
    return response.data;
};

// Activity Exclusions by Activity
export const getActivityExclusionsByActivity = async (activityId) => {
    const response = await apiMiddleware.get(`/activity-exclusions?activity_id=${activityId}`);
    return response.data;
};

// Activity Itinerary
export const getActivityItinerary = async (activityId, ticketTypeId) => {
    const response = await apiMiddleware.get(`/activities/${activityId}/ticket-types/${ticketTypeId}/itinerary`);
    return response.data;
};

export const createActivityItinerary = async (activityId, ticketTypeId, data) => {
    const response = await apiMiddleware.post(`/activities/${activityId}/ticket-types/${ticketTypeId}/itinerary`, data);
    return response.data;
};

export const updateActivityItinerary = async (activityId, ticketTypeId, stepId, data) => {
    const response = await apiMiddleware.put(`/activities/${activityId}/ticket-types/${ticketTypeId}/itinerary/${stepId}`, data);
    return response.data;
};

export const deleteActivityItinerary = async (activityId, ticketTypeId, stepId) => {
    const response = await apiMiddleware.delete(`/activities/${activityId}/ticket-types/${ticketTypeId}/itinerary/${stepId}`);
    return response.data;
};

// Activity Pricing
export const getActivityTicketTypePrices = async (activityId) => {
    const response = await apiMiddleware.get(`/activities/${activityId}/ticket-type-prices`);
    return response.data;
};

export const createActivityPriceForTicketType = async (activityId, ticketTypeId, data) => {
    const response = await apiMiddleware.post(`/activities/${activityId}/ticket-types/${ticketTypeId}/prices`, data);
    return response.data;
};

export const updateActivityTicketTypePrice = async (activityId, priceId, data) => {
    const response = await apiMiddleware.put(`/activities/${activityId}/ticket-type-prices/${priceId}`, data);
    return response.data;
};

export const syncActivitySlotPriceOverrides = async (activityId, slotPrices = []) => {
    const response = await apiMiddleware.post(`/activities/${activityId}/slot-price-overrides`, {
        slot_prices: Array.isArray(slotPrices) ? slotPrices : []
    });
    return response.data;
};

// Activity-level Time Slot Pricing (when `time_slot_based` is enabled)
export const getActivityTimeSlotPricing = async (activityId) => {
    const response = await apiMiddleware.get(`/activities/${activityId}/time-slot-pricing`);
    return response.data;
};

export const createActivityTimeSlot = async (activityId, data) => {
    const response = await apiMiddleware.post(`/activities/${activityId}/time-slots`, data);
    return response.data;
};

export const updateActivityTimeSlot = async (activityId, slotId, data) => {
    const response = await apiMiddleware.put(`/activities/${activityId}/time-slots/${slotId}`, data);
    return response.data;
};

export const deleteActivityTimeSlot = async (activityId, slotId) => {
    const response = await apiMiddleware.delete(`/activities/${activityId}/time-slots/${slotId}`);
    return response.data;
};

export const syncActivityTimeSlotTicketPrices = async (activityId, slotId, payload) => {
    const response = await apiMiddleware.post(
        `/activities/${activityId}/time-slots/${slotId}/ticket-prices`,
        payload
    );
    return response.data;
};

export const deleteActivityTicketTypePrice = async (activityId, priceId) => {
    const response = await apiMiddleware.delete(`/activities/${activityId}/ticket-type-prices/${priceId}`);
    return response.data;
};

// Activity Monthly/Seasonal Prices
export const getActivitySeasonalPrices = async (activityId) => {
    const response = await apiMiddleware.get(`/activities/${activityId}/seasonal-prices`);
    return response.data;
};

export const createActivitySeasonalPrice = async (activityId, data) => {
    const response = await apiMiddleware.post(`/activities/${activityId}/seasonal-prices`, data);
    return response.data;
};

export const updateActivitySeasonalPrice = async (activityId, seasonalPriceId, data) => {
    const response = await apiMiddleware.put(`/activities/${activityId}/seasonal-prices/${seasonalPriceId}`, data);
    return response.data;
};

export const deleteActivitySeasonalPrice = async (activityId, seasonalPriceId) => {
    const response = await apiMiddleware.delete(`/activities/${activityId}/seasonal-prices/${seasonalPriceId}`);
    return response.data;
};

// Activity Close Out Days
export const getActivityCloseOutDays = async (activityId) => {
    const response = await apiMiddleware.get(`/activities/${activityId}/close-out-days`);
    return response.data;
};

export const createActivityCloseOutDays = async (activityId, data) => {
    const response = await apiMiddleware.post(`/activities/${activityId}/close-out-days`, data);
    return response.data;
};

export const updateActivityCloseOutDays = async (activityId, closeOutId, data) => {
    const response = await apiMiddleware.put(`/activities/${activityId}/close-out-days/${closeOutId}`, data);
    return response.data;
};

export const deleteActivityCloseOutDays = async (activityId, closeOutId) => {
    const response = await apiMiddleware.delete(`/activities/${activityId}/close-out-days/${closeOutId}`);
    return response.data;
};

export const deleteActivityGalleryImage = async (id, imageId) => {
    const response = await apiMiddleware.post(
        `/activities/${id}/delete-gallery-image`,
        { image_ids: [imageId] }
    );
    return response;
};

// Activity FAQ functions
export const getActivityFAQ = async (activityId) => {
    const response = await apiMiddleware.get(`/activity-faqs/${activityId}`);
    return response.data;
};

export const createActivityFAQ = async (data) => {
    const response = await apiMiddleware.post(`/activity-faqs`, data);
    return response.data;
};

export const updateActivityFAQ = async (faqId, data) => {
    const response = await apiMiddleware.put(`/activity-faq/${faqId}`, data);
    return response.data;
};

export const deleteActivityFAQ = async (faqId) => {
    const response = await apiMiddleware.delete(`/activity-faq/${faqId}`);
    return response.data;
};

// Activity Terms and Conditions functions
export const getActivityTermsConditions = async (activityId) => {
    const response = await apiMiddleware.get(`/activity-terms-conditions/${activityId}`);
    return response.data;
};

export const createActivityTermsConditions = async (data) => {
    const response = await apiMiddleware.post(`/activity-terms-conditions`, data);
    return response.data;
};

export const updateActivityTermsConditions = async (termsId, data) => {
    const response = await apiMiddleware.put(`/activity-terms-condition/${termsId}`, data);
    return response.data;
};

export const deleteActivityTermsConditions = async (termsId) => {
    const response = await apiMiddleware.delete(`/activity-terms-condition/${termsId}`);
    return response.data;
};

// Activity Cancellation Policy functions
export const getActivityCancellationPolicies = async (activityId) => {
    const response = await apiMiddleware.get(`/activities/${activityId}/cancellation-policy`);
    return response.data;
};

export const createActivityCancellationPolicies = async (data) => {
    const response = await apiMiddleware.post(`/activities/cancellation-policy`, data);
    return response.data;
};

export const updateActivityCancellationPolicies = async (activityId, data) => {
    const response = await apiMiddleware.put(`/activities/${activityId}/cancellation-policy`, data);
    return response.data;
};

export const deleteActivityCancellationPolicies = async (activityId) => {
    const response = await apiMiddleware.delete(`/activities/${activityId}/cancellation-policy`);
    return response.data;
};
